import AssetStatusField from "./AssetStatusField";

export default AssetStatusField;
